import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  box-sizing: border-box;
  text-align: center;
`;

const Title = styled.h1`
  margin: 0 0 12px 0;
  font-size: 22px;
`;

const Desc = styled.p`
  margin: 0 0 16px 0;
  color: #555;
  line-height: 1.5;
`;

const Hint = styled.p`
  margin: 8px 0 0 0;
  color: #777;
  font-size: 14px;
`;

const DesktopBlocked: React.FC = () => {
  return (
    <Container>
      <Title>모바일 전용 페이지예요</Title>
      <Desc>
        현재 서비스는 모바일 환경에서만 이용 가능해요. 휴대폰으로 접속해주세요.
      </Desc>
      <Hint>PC에서 보려면 개발자 도구의 모바일 보기로 전환해도 돼요.</Hint>
    </Container>
  );
};

export default DesktopBlocked;


